/* Hemi Blurr interaction analytics v1. No ecommerce add_to_cart/page_view duplication. */
(() => {
  'use strict';
  const configNode = document.getElementById('hemi-analytics-context');
  if (!configNode) return;
  configNode.setAttribute('data-hemi-analytics-executed', 'true');
  if (window.HemiAnalytics) { configNode.setAttribute('data-hemi-analytics-duplicate', 'true'); return; }
  let context;
  try { context = JSON.parse(configNode.textContent); } catch (_) { return; }
  const debug = new URLSearchParams(location.search).get('hemi_analytics_debug') === '1';
  const onceKeys = new Set();
  const attempts = new WeakMap();
  const overrides = new WeakMap();
  const videos = new WeakMap();
  const userPlayed = new WeakSet();
  let videoGestureUntil = 0;
  let sequence = 0;
  let gtmLoaded = false;
  const allowed = () => {
    try {
      const api = window.Shopify?.customerPrivacy;
      configNode.setAttribute('data-hemi-privacy-api', typeof api?.analyticsProcessingAllowed);
      return api?.analyticsProcessingAllowed?.() === true;
    } catch (_) { return false; }
  };
  function loadGtm() {
    if (gtmLoaded || !allowed()) return;
    gtmLoaded = true;
    window.dataLayer = window.dataLayer || [];
    (function () { window.dataLayer.push(arguments); })('consent', 'update', { analytics_storage: 'granted' });
    if (document.querySelector('script[src*="googletagmanager.com/gtm.js?id=' + context.gtm_id + '"]')) return;
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=' + context.gtm_id;
    document.head.appendChild(script);
  }
  function send(name, params = {}) {
    configNode.setAttribute('data-hemi-analytics-consent', String(allowed()));
    if (!allowed()) return false;
    loadGtm();
    const data = Object.assign({
      theme_id: context.theme_id, theme_variant: context.theme_variant,
      page_type: context.page_type, template_version: context.template_version,
      product_id: context.product_id || undefined, collection_id: context.collection_id || undefined,
      tracking_version: '1.0.0', page_location: location.origin + location.pathname
    }, params);
    if (debug) data.debug_mode = true;
    window.dataLayer.push({ hemi_event_params: null });
    window.dataLayer.push({ event: 'hemi_interaction', hemi_event_name: name, hemi_event_params: data });
    if (debug) {
      let output = document.getElementById('hemi-analytics-debug');
      if (!output) { output = document.createElement('pre'); output.id = 'hemi-analytics-debug'; output.hidden = true; document.body.appendChild(output); }
      output.textContent += JSON.stringify({event:name,params:data}) + '\n';
    }
    return true;
  }
  function once(key, name, params) {
    if (!onceKeys.has(key) && send(name, params)) onceKeys.add(key);
  }
  function source(button) {
    if (!button) return 'other';
    if (overrides.has(button)) {
      const value = overrides.get(button); overrides.delete(button); return value;
    }
    const annotated = button.closest('[data-hemi-atc-location]');
    if (annotated) return annotated.getAttribute('data-hemi-atc-location');
    if (button.closest('[data-hemi-wishlist-drawer], [data-hemi-wishlist-size-sheet], [data-hemi-wishlist-page]') || button.matches('[data-hemi-wishlist-add]')) return 'wishlist';
    if (button.closest('[data-shop-the-look-modal], .alp-shop-the-look-pdp, [data-shop-the-look-panel], .shop-the-look-modal, [data-hemi-shop-the-look]')) return 'shop_the_look';
    if (button.closest('.js-footbar-product, [data-js-product-clone="footbar"]') || button.matches('[data-pdp-sticky-choose-size], [data-js-mobile-floating-add-to-cart-btn], [data-js-button-add-to-cart-clone]')) return 'sticky';
    return button.closest('[data-js-product-clone-id="footbar"], .product-page-pdp, .product-page') ? 'main' : 'quick_add';
  }
  function begin(button, data, locationOverride) {
    const location = locationOverride || source(button);
    const attempt = { attempt_id: String(Date.now()) + '-' + (++sequence), atc_location: location,
      product_id: String(data?.productId || (['main','sticky'].includes(location) ? context.product_id || '' : '')), variant_id: String(data?.id || data?.variantId || ''), quantity: Number(data?.quantity || 1) };
    if (button) attempts.set(button, attempt);
    return attempt;
  }
  function result(attempt, response) {
    if (!attempt || attempt.finished) return;
    attempt.finished = true;
    if (response?.ok) send('atc_success', attemptParams(attempt));
    else send('add_to_cart_error', Object.assign(attemptParams(attempt), {
      error_reason: !response ? 'network_error' : response.status === 422 ? 'unavailable_or_invalid_variant' : 'request_failed'
    }));
  }
  function attemptParams(attempt) {
    const { finished, ...params } = attempt; return params;
  }
  function wishlist(item) {
    send('add_to_wishlist', { product_id: String(item.id || item.handle || ''), variant_id: String(item.variantId || ''), item_name: item.title || '' });
  }
  function zoom(index, mode) {
    const media = context.media?.[Number(index)];
    if (!media || media.media_type !== 'image') return;
    once('zoom:' + mode + ':' + media.id, 'product_image_zoom', {
      image_id: String(media.id), image_position: Number(index) + 1, zoom_mode: mode
    });
  }
  function trackCart(button, data, run) {
    const attempt = begin(button, data);
    return Promise.resolve().then(() => run(attempt)).then(response => { result(attempt, response); return response; }, error => { result(attempt, null); throw error; });
  }
  function forward(button, targets, run) {
    const location = source(button);
    Array.from(targets).forEach(target => overrides.set(target, location));
    try { return run(); } finally { Array.from(targets).forEach(target => overrides.delete(target)); }
  }
  window.HemiAnalytics = { send, once, source, begin, result, wishlist, zoom, trackCart, forward,
    override(button, location) { if (button) overrides.set(button, location); },
    debug: debug ? { version: '1.0.0', context, consentAllowed: allowed } : undefined
  };
  // Source annotations are captured by the actual request caller, never inferred from a later cart event.
  const atcSelector = '[data-js-product-button-add-to-cart], [data-hemi-wishlist-add], .size-option-btn, [data-pdp-sticky-choose-size], [data-js-mobile-floating-add-to-cart-btn]';
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !event.isTrusted) return;
    const el = event.target;
    const atc = el.closest(atcSelector);
    if (atc && !atc.disabled && atc.getAttribute('aria-disabled') !== 'true') {
      send('atc_click', { atc_location: source(atc), size_selected: !document.querySelector('[data-pdp-size-dropdown]:not([data-pdp-size-picked])') });
    }
    const tab = el.closest('.info__tab_btn[data-tab], [data-pdp-tab], [data-pdp-accordion-trigger], .product-page__tabs [data-js-tabs-btn], .product-page__tabs [data-js-tabs-btn-mobile]');
    if (tab) {
      const raw = tab.dataset.tab || tab.dataset.pdpTab || tab.textContent;
      const aliases = { return: 'shipping_returns', 'shipping-returns': 'shipping_returns', 'product-details': 'product_details', 'size-fit': 'size_fit', 'fabric-care': 'fabric_care' };
      send('pdp_tab_select', { tab_name: aliases[raw] || String(raw).trim().toLowerCase().replace(/[^a-z0-9]+/g, '_') });
    }
    const guide = el.closest('[data-pdp-size-sheet-open], [data-js-popup-button="size-guide"], [data-js-popup-button="size-guide-pdp"], [data-size-guide-open]');
    if (guide) send('size_guide_open', { entry_point: 'pdp' });
    const videoButton = el.closest('[data-pdp-gallery-video-jump], [data-js-product-gallery-control-video]');
    if (el instanceof HTMLVideoElement) userPlayed.add(el);
    if (videoButton) { videoGestureUntil = Date.now() + 3000; send('product_video_button_click', { video_id: String(context.media?.find(media => media.media_type === 'video')?.id || videoParams(document.querySelector('.pdp-gallery-video__video')).video_id), placement: 'gallery', device_context: matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop' }); }
    const filterButton = el.closest('[data-hemi-filter-open]');
    if (filterButton && !document.querySelector('[data-hemi-filter-panel].is-open')) send('collection_filter_open');
    const stlItem = el.closest('.shop-the-look-modal a[href*="/products/"], .shop-the-look-modal .quick-add-trigger, [data-hemi-shop-the-look] a[href*="/products/"], [data-hemi-shop-the-look] .quick-add-trigger');
    if (stlItem) {
      const card = stlItem.closest('[data-product-id], [data-pdp-slider-card]');
      const href = stlItem.getAttribute('href') || stlItem.dataset.productUrl || '';
      send('shop_the_look_select_item', { selected_product_id: card?.dataset.productId || stlItem.dataset.productId || '', selected_product_handle: href.split('/products/')[1]?.split(/[?#/]/)[0] || '', action_type: stlItem.matches('.quick-add-trigger') ? 'quick_add' : 'product_view' });
    }
  }, true);
  function scrollDepth() {
    if (!['product','collection'].includes(context.page_type)) return;
    const height = document.documentElement.scrollHeight;
    const depth = Math.min(100, ((window.scrollY + window.innerHeight) / height) * 100);
    [20,50,75].forEach(n => { if (depth >= n) once('scroll:' + n, 'scroll_depth', { percent_scrolled: n }); });
  }
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; scrollDepth(); observeButtons(); });
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  const observed = new WeakSet();
  const buttonObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const button = entry.target;
      if (entry.intersectionRatio < .5 || button.disabled || !button.getClientRects().length) return;
      const style = getComputedStyle(button);
      if (style.visibility === 'hidden' || style.display === 'none') return;
      const location = source(button);
      if (!['main','sticky'].includes(location)) return;
      const key = 'atc-impression:' + location;
      once(key, 'atc_impression', { atc_location: location });
      if (onceKeys.has(key)) buttonObserver.unobserve(button);
    });
  }, { threshold: [.5] }) : null;
  function observeButtons() {
    if (!buttonObserver) return;
    document.querySelectorAll(atcSelector).forEach(button => {
      if (!observed.has(button) && !button.disabled) { observed.add(button); buttonObserver.observe(button); }
    });
  }
  // Accumulate watched segments; seeking cannot award unwatched milestones.
  function stateFor(video) {
    if (!videos.has(video)) videos.set(video, { last: null, segments: [], started: false });
    return videos.get(video);
  }
  function videoParams(video) {
    if (!video) return { video_id: 'product_video' };
    const slide = video.closest('[data-item-index]');
    const media = context.media?.[Number(slide?.dataset.itemIndex)];
    return { video_id: String((media?.media_type === 'video' ? media.id : '') || (video.currentSrc || video.querySelector('source')?.src || video.src).split('?')[0].split('/').pop() || 'product_video'), placement: video.closest('.product-gallery__fullscreen') ? 'gallery_fullscreen' : 'gallery', playback_type: userPlayed.has(video) ? 'user_initiated' : 'autoplay' };
  }
  function isProductVideo(video) { return video instanceof HTMLVideoElement && !!video.closest('[data-js-product-gallery], .product-gallery__fullscreen, [data-pdp-other-gallery]'); }
  function recordVideo(video) {
    const state = stateFor(video), time = video.currentTime;
    const bounds = video.getBoundingClientRect();
    if (document.visibilityState === 'hidden' || !video.getClientRects().length || bounds.bottom <= 0 || bounds.top >= window.innerHeight || bounds.right <= 0 || bounds.left >= window.innerWidth) { state.last = null; return; }
    const wrapped = video.loop && Number.isFinite(video.duration) && state.last >= video.duration - .5 && time < .5 && time < state.last;
    if ((!video.paused || video.ended) && state.last != null && !video.seeking && ((time > state.last && time - state.last <= 2) || wrapped)) {
      if (wrapped) state.segments.push([state.last, video.duration], [0, time]);
      else state.segments.push([state.last, time]);
      state.segments.sort((a,b) => a[0]-b[0]);
      const merged = [];
      state.segments.forEach(seg => { const prev = merged[merged.length-1]; if (prev && seg[0] <= prev[1] + .05) prev[1] = Math.max(prev[1],seg[1]); else merged.push(seg.slice()); });
      state.segments = merged;
      const seconds = merged.reduce((sum, seg) => sum + seg[1]-seg[0],0);
      if (Number.isFinite(video.duration) && video.duration > 0) {
        const percentage = Math.min(100,seconds/video.duration*100);
        const params = videoParams(video);
        [25,50,75,100].forEach(n => { if (percentage >= (n === 100 ? 99 : n)) once('video:' + params.video_id + ':' + n, 'product_video_progress', Object.assign({},params,{video_percent:n})); });
      }
    }
    state.last = time;
  }
  document.addEventListener('playing', event => {
    const video = event.target;
    if (!isProductVideo(video)) return;
    if (Date.now() <= videoGestureUntil) userPlayed.add(video);
    const state = stateFor(video), params = videoParams(video);
    once('video-start:' + params.video_id, 'product_video_start', params);
    state.last = video.currentTime;
  },true);
  document.addEventListener('timeupdate', event => { if (isProductVideo(event.target)) recordVideo(event.target); },true);
  document.addEventListener('seeking', event => { if (isProductVideo(event.target)) stateFor(event.target).last = null; },true);
  document.addEventListener('seeked', event => { if (isProductVideo(event.target)) stateFor(event.target).last = event.target.currentTime; },true);
  document.addEventListener('pause', event => { if (isProductVideo(event.target) && !event.target.ended) stateFor(event.target).last = null; },true);
  document.addEventListener('ended', event => { if (isProductVideo(event.target)) recordVideo(event.target); },true);
  function filterState() {
    const params = new URLSearchParams(location.search), groups = {};
    params.forEach((value,key) => { if (key.startsWith('filter.')) (groups[key] ||= []).push(value); });
    Object.values(groups).forEach(values => values.sort());
    return { groups, sort: params.get('sort_by') || document.getElementById('SortBy')?.value || 'manual' };
  }
  let previousFilters = filterState();
  function category(key) {
    if (/price/.test(key)) return 'price';
    if (/colou?r/i.test(key)) return 'colour';
    if (/size/i.test(key)) return 'size';
    if (/product_type|category/i.test(key)) return 'category';
    if (/availability/.test(key)) return 'availability';
    if (/vendor/.test(key)) return 'brand';
    if (/material|fabric/.test(key)) return 'fabric';
    if (/characteristic/.test(key)) return 'characteristics';
    if (/tag/.test(key)) return 'tags';
    return 'other';
  }
  function filtersApplied() {
    if (context.page_type !== 'collection') return;
    const next = filterState();
    const changed = [...new Set([...Object.keys(next.groups),...Object.keys(previousFilters.groups)])].filter(key => JSON.stringify(next.groups[key] || []) !== JSON.stringify(previousFilters.groups[key] || []));
    if (changed.length) {
      const categories = [...new Set(Object.keys(next.groups).map(category))];
      const countNode = document.getElementById('CollectionProductCount') || document.getElementById('SearchResultsCount');
      const count = Number((countNode?.textContent || '').replace(/,/g,'').match(/\d+/)?.[0]);
      send('collection_filter_apply', { filter_categories: categories.join('|') || 'none', result_count: Number.isFinite(count) ? count : undefined });
      [...new Set(changed.map(category))].forEach(name => send('collection_filter_category_apply',{filter_category:name}));
    }
    if (next.sort !== previousFilters.sort) send('collection_sort_change',{sort_order:next.sort});
    previousFilters = next;
    observeButtons();
  }
  window.HemiAnalytics.filtersApplied = filtersApplied;
  function consentReady() {
    configNode.setAttribute('data-hemi-analytics-consent', String(allowed()));
    configNode.setAttribute('data-hemi-privacy-api', typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed);
    if (!allowed() && gtmLoaded) (function () { window.dataLayer.push(arguments); })('consent', 'update', { analytics_storage: 'denied' });
    loadGtm(); schedule();
  }
  document.addEventListener('visitorConsentCollected', consentReady);
  if (debug) {
    const panel = document.createElement('details');
    panel.id = 'hemi-analytics-qa';
    panel.style.cssText = 'position:fixed;bottom:12px;left:12px;z-index:2147483646;background:white;color:black;border:1px solid #999;padding:8px;max-width:520px;max-height:240px;overflow:auto;font:12px monospace';
    panel.innerHTML = '<summary>Analytics QA</summary><button type="button" data-hemi-qa-consent>Allow analytics in this test browser</button><pre id="hemi-analytics-debug" style="white-space:pre-wrap"></pre>';
    panel.querySelector('button').addEventListener('click', () => {
      const api = window.Shopify?.customerPrivacy;
      if (typeof api?.setTrackingConsent !== 'function') return;
      api.setTrackingConsent({ analytics: true }, consentReady);
    });
    document.body.appendChild(panel);
  }
  consentReady();
  configNode.setAttribute('data-hemi-analytics-ready', '1.0.0');
  try {
    if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { configNode.setAttribute('data-hemi-privacy-load', error ? String(error) : 'loaded'); consentReady(); });
  } catch (error) { configNode.setAttribute('data-hemi-privacy-load', 'unavailable'); }
  window.addEventListener('load', consentReady, {once:true});
})();
